/**
 * Routes whose URL carries a bearer credential: `/join/:token` (legacy
 * invitation links) and `/h/:code?t=` (huddle short links). No Google tag,
 * no session replay and no soft navigation may see them: a GTM container or
 * a replay session started on `/spaces` stays alive across an in-app
 * navigation, so entering these routes is always a document navigation and
 * replay is stopped route-aware on top of the boot-time check.
 */
export const CREDENTIAL_ROUTE_PREFIXES = ['/join', '/h'] as const;

/** Same-origin path (or href) check; absolute URLs on this origin count too. */
export const isCredentialRoutePath = (href: string | null | undefined): boolean => {
	if (!href) return false;
	let path = href;
	if (/^https?:\/\//i.test(href)) {
		try {
			const url = new URL(href);
			if (typeof window !== 'undefined' && url.origin !== window.location.origin) return false;
			path = url.pathname;
		} catch {
			return false;
		}
	}
	if (!path.startsWith('/') || path.startsWith('//')) return false;
	const pathname = path.split(/[?#]/, 1)[0];
	return CREDENTIAL_ROUTE_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
};
